export default class {
  static projectName = "idpl";
  static userData = "USER_DATA";
  //   static themeColor = "#ff0000";
  static emailRjx = /\S+@\S+\.\S+/;

  // static API_URL = "http://192.168.1.162:8087";
  // static API_URL = "http://192.168.1.148:7001";
  static API_URL = "https://api.idplindia.in";
}
